<template>

<svg width="765px" height="425px" viewBox="0 0 765 425" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 49.3 (51167) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="RIGA---Home-Copy" transform="translate(-89.000000, -438.000000)" fill="#FFFFFF">
            <g id="Animation_RIBOCA" transform="translate(89.000000, 438.000000)">
                <path d="M287.324,115 L266.42,115 L266.42,103.768 L251.6,72.88 L225.704,72.88 L225.704,115 L204.8,115 L204.8,0.028 L250.976,0.028 C270.944,0.028 287.324,16.252 287.324,36.22 C287.324,48.856 280.772,60.088 270.944,66.64 L286.388,96.436 C286.856,97.84 287.324,99.4 287.324,100.96 L287.324,115 Z M266.576,36.688 C266.576,27.64 259.4,20.464 250.664,20.464 L225.392,20.464 L225.392,52.6 L250.664,52.6 C259.4,52.6 266.576,45.424 266.576,36.688 Z" id="H1"></path>
                <polygon id="H2" points="487.368 115 426.06 115 426.06 93.94 446.964 93.94 446.964 21.088 426.06 21.088 426.06 0.028 487.368 0.028 487.368 21.088 467.868 21.088 467.868 93.94 487.368 93.94"></polygon>
                <path d="M285.504,225.656 C285.504,248.432 266.94,266.84 244.164,266.84 C221.388,266.84 202.98,248.432 202.98,225.656 L202.98,188.372 C202.98,165.596 221.388,147.188 244.164,147.188 C266.94,147.188 285.504,165.596 285.504,188.372 L285.504,225.656 Z M264.6,225.656 L264.6,188.528 C264.6,177.296 255.396,168.248 244.008,168.248 C233.088,168.248 223.884,177.452 223.884,188.372 L223.884,225.656 C223.884,236.576 233.088,245.78 244.164,245.78 C255.396,245.78 264.6,236.576 264.6,225.656 Z" id="H3"></path>
                <path d="M83.224,227.84 C83.224,248.12 66.844,264.5 46.72,264.5 L0.7,264.5 L0.7,149.528 L46.72,149.528 C63.568,149.528 77.296,163.256 77.296,180.26 C77.296,187.592 74.488,194.456 70.12,199.916 C78.076,206.78 83.224,216.764 83.224,227.84 Z M56.236,181.04 C56.236,175.268 51.712,170.744 45.94,170.744 L21.604,170.744 L21.604,191.648 L46.096,191.648 C51.712,191.648 56.236,186.812 56.236,181.04 Z M62.32,227.528 C62.164,218.324 54.832,210.992 45.94,210.992 L21.604,210.992 L21.604,243.596 L46.252,243.596 C54.988,243.596 62.32,236.42 62.32,227.528 Z" id="H4"></path>
                <path d="M622.048,228.776 C620.488,250.304 602.704,266.84 580.864,266.84 C558.088,266.84 539.68,248.432 539.68,225.656 L539.68,188.372 C539.68,165.596 558.088,147.188 580.864,147.188 C602.704,147.188 620.488,163.724 622.048,185.252 L601.3,188.528 C601.3,177.296 592.096,168.248 580.864,168.092 C569.944,168.092 560.896,177.14 560.896,188.372 L560.896,225.656 C560.896,236.576 569.944,245.78 580.864,245.78 C592.096,245.78 601.3,236.576 601.3,225.656 L622.048,228.776 Z" id="H5"></path>
                <path d="M621.424,419.2 L600.364,419.2 L600.364,409.216 L597.088,397.672 L563.704,397.672 L560.584,409.216 L560.584,419.2 L538.9,419.2 L538.9,410.62 C538.9,409.216 539.056,407.968 539.68,406.72 L570.256,304.228 L589.756,304.228 L620.488,406.408 C620.8,407.656 621.424,409.06 621.424,410.464 L621.424,419.2 Z M591.472,377.548 L580.084,336.988 L569.164,377.548 L591.472,377.548 Z" id="H6"></path>
                <path d="M724.375381,404.848819 L724.375381,340.903633 C716.81184,346.918929 708.208531,351.580524 698.864516,354.588914 L698.864516,332.934145 C711.916451,327.821069 722.299502,317.594176 728.380899,304.812598 L744.251613,304.812598 L744.251613,404.848819 L764.423656,404.848819 L764.423656,425 L704.916129,425 L704.916129,404.848819 L724.375381,404.848819 Z" id="H7"></path>
            </g>
        </g>
    </g>
</svg>

</template>

<script>
  export default {
    data() {
      return {
        speed:0.3,
        delay:0,
        step:0,
        increment:0.2,
        tl:'',
        easing: Power1.easeOut
      }
    },
    props: ['closed'],
    mounted() {
      this.delay = 0;
      this.step = 0;
      this.animateIn();
      
    },
    computed: {
      transitionState() {
        return this.$store.state.transitionState;
      }
    },
    watch: {
      transitionState(newVal) {
        console.log('start changed');
        this.step = 0;
        this.animateIn();
      }
    },
    methods: {
      animateIn() {
        console.log('animate in');
        // this.step = 0;
        // this.delay= 0;
        this.tl = new TimelineLite();
        this.tl.fromTo('#H1', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.fromTo('#H2', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.fromTo('#H3', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.fromTo('#H4', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.fromTo('#H5', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.fromTo('#H6', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.fromTo('#H7', this.speed,{opacity:0} , {opacity:1, ease: this.easing}, this.getStartTime())
        this.tl.play();
      },
      incrementStep() {
        this.step += this.increment;
      },
      getStartTime() {
        this.incrementStep();
        return this.delay + this.step;
      }
    },
  }
</script>

<style lang="scss">
  #H1, #H2, #H3, #H4, #H5, #H6, #H7, #Everything-Was-Forev {
    opacity: 1;
  }
  svg {
    width: 100%;
    height: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/HomeRiboca.vue